<template>
  <div @click="clickFun">
    <svg class="icon" aria-hidden="true">
      <use :xlink:href="iconId"></use>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    iconId: {
      type: String
    },
    //用于删除
    deleteFlag: {
      type: Boolean,
      default: false
    },
    //用于重新上传
    reUploadFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickFun() {
      if (this.deleteFlag) {
        this.$emit("delFun");
      }
      if (this.reUploadFlag) {
        this.$emit("reUploadFun");
      }
    }
  }
};
</script>
